import React from "react";
import PageLoadingState from "./page-loading-state";
import { useIsMobile } from "../hooks/use-is-mobile";

const SettingsSectionLoading: React.FC = () => {
  const isMobile = useIsMobile();

  if (!isMobile) return <PageLoadingState showAnalytics={false} />;

  return (
    <div className="space-y-2.5">
      <div className="h-11 w-full animate-pulse rounded-xl bg-gray-200" />
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="h-24 w-full animate-pulse rounded-2xl bg-gray-200" />
      ))}
    </div>
  );
};

export default SettingsSectionLoading;
